import React, { useContext, useState, useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { H1 } from "components/core/Typography";
import { FilterIconSolid } from "components/core/Icons";
import "./StickToolBar.scss";
import { Button } from "components/core/Button";
import ClickToCall from "components/brand/ClickToCall/ClickToCall";
import useTollfreeNumber from "hooks/useTollfreeNumber";
import SearchPageContext from "pages/SearchPageV1/SearchPageV1Context";
import { FiltersCard } from "components/organisms/search/Filters";
import SearchBar from "../SearchBar/SearchBar";


function StickToolBar({ headingTitle = "", filterCount = 0, location = "" }) {

    const [isScrolling, setIsScrolling] = useState(false);

    const {
        isCallCenterOpen,
        showInlineFilters,
        setShowInlineFilters,
        searchFilters,
        handleFilterChange,
        filtersContainerRef
    } = useContext(SearchPageContext);
    const { phone, handleFetchNumber } = useTollfreeNumber();

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 0) {
                setIsScrolling(true);
            } else {
                setIsScrolling(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <div className={classNames("stick-toolbar", { "stick-toolbar--fixed": isScrolling })}>
            <H1
                className="heading"
                color="white"
                weight="bold"
                size="small"
                data-testid="heading"
            >
                {headingTitle} {location}
            </H1>
            <div className="searchbar-container">
                <div className="help-filter-btn" data-testid="callContainer">
                    {!!isCallCenterOpen && (
                        <div>
                            <ClickToCall
                                className="tray-button tray-button--call"
                                color="white"
                                showIcon
                                underline={false}
                                phone={phone}
                                handleFetchNumber={handleFetchNumber}
                                iconSize="large"
                            />
                        </div>
                    )}
                    <div
                        className="stick-toolbar__filters"
                        ref={filtersContainerRef}
                    >
                        <Button
                            type="button"
                            className={classNames("filter-button", {
                                "is-active": !!showInlineFilters
                            })}
                            aria-haspopup="dialog"
                            aria-expanded={!!showInlineFilters}
                            aria-pressed={showInlineFilters ? "true" : "false"}
                            onClick={() => {
                                if (typeof setShowInlineFilters === "function") {
                                    setShowInlineFilters(!showInlineFilters);
                                }
                            }}
                        >
                            <FilterIconSolid size="large" fill="white" aria-hidden />
                            <span className="filter-btn-label">Filter</span>
                            {filterCount > 0 && <div className="filter-btn-count">
                                <span
                                    className="filter-btn-num"
                                    aria-label={`Applied filters: ${filterCount}`}
                                >
                                    {filterCount}
                                </span>
                            </div>}
                        </Button>
                        {showInlineFilters && searchFilters && (
                            <div
                                className="stick-toolbar__filters-popover"
                                role="dialog"
                                aria-label="Filters"
                            >
                                <FiltersCard
                                    onFilterChange={handleFilterChange}
                                    navigateOnChange
                                    activeFilters={searchFilters}
                                    onClose={() => {
                                        if (typeof setShowInlineFilters === "function") {
                                            setShowInlineFilters(false);
                                        }
                                    }}
                                />
                            </div>
                        )}
                    </div>
                </div>
                <SearchBar
                    buttonText="Find Storage"
                    id="hero-search-bar"
                    label="Search by city, state, or zip"
                    theme="darkBlue"
                    showLabel={false}
                    className="searchbar"
                    location={location}
                />
            </div>
        </div>
    );
}

StickToolBar.propTypes = {
    headingTitle: PropTypes.string,
    filterCount: PropTypes.number,
    location: PropTypes.string
};

export default StickToolBar;
